import {
	type CustomEvent,
	type OptionCommon,
	type OptionRaw,
	type OptionTransformed,
} from 'webapp/components/form/select';
import FormSelectWithActionComponent from 'webapp/components/form/select-with-action';

export default class SelectWithClickableLabel3 extends FormSelectWithActionComponent {
	override formatResult(
		item: OptionTransformed<string>,
		isOnList = false,
	): JQuery<HTMLElement> | '' {
		const html = super.formatResult(item, isOnList) as JQuery<HTMLElement>;

		if (item.onLabel3Click) {
			const label3El = html.find('.label3');
			label3El.on('click', () => {
				item.onLabel3Click!();
				this._selectElement?.select2('close');
				return false;
			});
		}
		return html;
	}

	override setupCustomEvents(): CustomEvent[] {
		const customEvents = super.setupCustomEvents();

		customEvents.push({
			target: this._selectElement!,
			event: 'select2:selecting',
			fn: (event) => {
				const e = event as JQuery.TriggeredEvent & {
					params: {
						args: { data: OptionCommon; originalEvent: { target: HTMLDivElement } };
					};
				};
				if (
					!!e.params.args.data.onLabel3Click &&
					e.params.args.originalEvent.target.parentElement?.className === 'label3'
				) {
					e.preventDefault();
				}
			},
		});

		return customEvents;
	}

	override defaultTransformOption(option: OptionRaw<string>): OptionTransformed<string> {
		const transformed = super.defaultTransformOption(option) as OptionTransformed<string>;

		return {
			...transformed,
			onLabel3Click: option.onLabel3Click,
		};
	}
}
